import { render, staticRenderFns } from "./FieldListComponent.vue?vue&type=template&id=28b95c53&scoped=true&"
import script from "./FieldListComponent.vue?vue&type=script&lang=js&"
export * from "./FieldListComponent.vue?vue&type=script&lang=js&"
import style0 from "./FieldListComponent.vue?vue&type=style&index=0&id=28b95c53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b95c53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
